import { toggleConfirmationPopup } from 'actions/placeorder';
import { isOptions } from 'helpers/utils';
import { APP_DRAWER_TAB_ID_MAPPING } from 'reducers/initialstate/appDrawer';
import {
  alwaysShowOnMobileSelector,
  appDrawerSelector,
  fatFingerProtectionSelector,
  marketOrderUserPreferenceSelector,
  orderPlacedFromChartsSelector,
} from 'selectors/otherSelectors';
import {
  impactSizeErrorSelector,
  isFormValidSelector,
  quantityInputDropdownValue,
  quantityInputValueInContract,
  sideSelection,
  slippageCheckSelector,
} from 'selectors/placeOrderSelector';
import { selectedContractTypeSelector } from 'selectors/tradeSelectors';

import submitOrder from '../ConfirmationModals/orderSubmit.thunk';
import handleError from '../QuantityInput/handleErrors.thunk';

const submitThunk = () => (dispatch, getState) => {
  const state = getState();
  const isFormValid = isFormValidSelector(state);
  const selectedDropdown = quantityInputDropdownValue(state);
  const side = sideSelection(state);
  if (!isFormValid) {
    const value = quantityInputValueInContract(state);
    dispatch(handleError(value, selectedDropdown, side, true));
    return false;
  }
  const showConfirmation = marketOrderUserPreferenceSelector(state);
  const showFatFingers = fatFingerProtectionSelector(state);
  const alwaysShowOnMobile = alwaysShowOnMobileSelector(state);
  const orderFromChart = orderPlacedFromChartsSelector(state);
  const { activeTab } = appDrawerSelector(state);

  const slippageCheckError = slippageCheckSelector(state);
  const impactSizeError = impactSizeErrorSelector(state);
  const selectedContractType = selectedContractTypeSelector(state);

  if (!orderFromChart && activeTab === APP_DRAWER_TAB_ID_MAPPING.CHART_ORDERBOOK) {
    dispatch(submitOrder());
    return true;
  }

  // For options not showing confirmation popup because calculations are incorrect and also UI will break
  // TODO: Remove this after calculations are fixed
  if (isOptions(selectedContractType)) {
    dispatch(submitOrder());
    return true;
  }

  if (
    showConfirmation ||
    (showFatFingers && (impactSizeError || slippageCheckError)) ||
    (window.innerWidth <= 640 && alwaysShowOnMobile)
  ) {
    dispatch(toggleConfirmationPopup(true));
  } else {
    dispatch(submitOrder());
  }
  return true;
};

export default submitThunk;
